import { Checkbox, FormControlLabel, FormControlLabelProps, Switch, SwitchProps } from '@mui/material';
import React from 'react';
import { useController } from 'react-hook-form';

type FormTextFieldProps = SwitchProps & {
  name: string;
  label: React.ReactNode;
  disabled?: boolean;
  small?: boolean;
  disabledAsChecked?: boolean;
  checkbox?: boolean;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
};

const FormSwitch = ({
  name,
  label,
  disabled,
  small,
  disabledAsChecked = false,
  checkbox,
  labelPlacement,
  ...rest
}: FormTextFieldProps) => {
  const { field } = useController({ name, defaultValue: false });

  return (
    <FormControlLabel
      sx={{ width: '100%', ml: 0, mr: 0 }}
      labelPlacement={labelPlacement}
      control={
        checkbox ? (
          <Checkbox
            size={small ? 'small' : 'medium'}
            color="secondary"
            checked={disabled ? disabledAsChecked : field.value || false}
            disabled={disabled}
            {...field}
            {...rest}
          />
        ) : (
          <Switch
            size={small ? 'small' : 'medium'}
            color="secondary"
            checked={disabled ? disabledAsChecked : field.value || false}
            disabled={disabled}
            {...field}
            {...rest}
          />
        )
      }
      label={label}
    />
  );
};

export default FormSwitch;
